var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.$options._componentTag === 'm-select')?_c('span',_vm._b({staticClass:"mdc-floating-label",class:_vm.classes},'span',_vm.$attrs,false),[_vm._t("default")],2):_c('label',_vm._b({staticClass:"mdc-floating-label",class:_vm.classes},'label',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }